import React, { useState, useEffect, useRef, useContext } from 'react'
import backBtn from "../../../../assets/images/back-arrow.svg"
import errorSVG from "../../../../assets/images/error.svg"
import deleteImg from "../../../../assets/images/delete.svg"

import SimpleReactValidator from "simple-react-validator"
import TextField from '../../../../components/formFields/textField/textField'
import { PublicContextInitiator } from '../../../apis/publicContextInitiator'
import AppContextObject from '../../../../common/context/common'
import toast from "react-hot-toast"
import Compress from "compress.js"
import { addHttpsInUrl, objectDeepClone } from '../../../../service/helper'
import ImageCroper from '../../../../components/addon/imageCroper'
import editSvg from "../../../../assets/images/edit-btn.svg"
import noImg from "../../../../assets/images/blank-inventory-img.jpg"
import plusIcon from "../../../../assets/images/plus-icon.svg"
import ConfirmDialog from '../../../../components/addon/confirmDialog/confirmDialog'

const EditGeneral = (props) => {
    const {
        generalDetail,
        setGeneralDetail,
        setOverlay,
        refetch,
        setRefetch,
        profileData,
        isBackendUser,
        backendCompanyId,
        backendUserRole
    } = props
    const context = useContext(AppContextObject)
    const compress = new Compress()
    const [formValidator] = useState(useRef(new SimpleReactValidator({
        element: (message, className) =>
            <p className="valError"><img src={errorSVG} />{message}</p>
    })))
    const [editingData, setEditingData] = useState(false)
    const [formData, setFormData] = useState(generalDetail)
    const [loading, setLoading] = useState(false)
    const [update, forceUpdate] = useState(false)
    const [showModalTwoMore, setShowModalTwoMore] = useState(false)
    const [imageFile, setImageFile] = useState<any>(null)
    const [showModal, setShowModal] = useState(false)
    const [logo, setLogo] = useState<any>(null)
    const [otherLinksError,setOtherLinksError] = useState([])
    const [editingGeneralData, setEditingGeneralData] = useState(false)
    const [showOtherLinkError, setShowOtherLinkError] = useState(false)
    const [reoveImgToggle, setReoveImgToggle] = useState(false)
    
    useEffect(() => {
        if(logo){
            handleCroppedLogoUpload(logo)
        }
    }, [logo])

    const handleCroppedLogoUpload = async(logo) => {
        const formData1 = new FormData();
        setLoading(true)
        const resizedImage = await compress.compress([logo], {
            size: 2, // the max size in MB, defaults to 2MB
            quality: 0.4, // the quality of the image, max is 1,
            resize: false // defaults to true, set false if you do not want to resize the image width and height
        }).catch(err => {
            console.log("Error while compressing....", err)
        })
        const img = resizedImage[0];
        const base64str = img.data
        const imgExt = img.ext
        let compressedFile = Compress.convertBase64ToFile(base64str, imgExt)
        formData1.append(`image`,compressedFile, img.alt)
        let reqBody = formData1
        // let destinationFolder = `brands/${context?.user?.parentBrand ? context?.user?.parentBrand : context?.user?.brand}-${context?.user?.companyName ? context?.user?.companyName.trim() : context?.user?.brandName.trim()}`
        let destinationFolder = `brands/${context?.user?.parentBrand ? context?.user?.parentBrand : context?.user?.brand}`
        if(isBackendUser){
            destinationFolder = `brands/${backendCompanyId}`
        }
        reqBody.append('destinationFolder',destinationFolder)

        // formData1.append(`image`, e.target.files[0]);
        const requestOptions = {
            method: 'POST',
            body: reqBody
        };
    
        let publicContextInitiator = new PublicContextInitiator(context)
        fetch('/api/uploadFiles', requestOptions)
            .then(response => {
                response.json()
                .then(res=>{
                    let data = [];
                    res["response"].map(async item=>{
                        data.push(item.Key)
                    })
                    publicContextInitiator.getUploadedImagesSignedUrl(
                        context.validator, {keys: data}
                    ).then(res=>{
                        let updateImageObj = []
                            let requests = res.response.map(item=>{
                            updateImageObj.push({image: item.image, key: item.key});
                            console.log(updateImageObj)
                                setFormData({...formData, logo: updateImageObj})
                        })
                        Promise.all(requests).then(() => {
                            setLoading(false)
                        });                       
                    })
                })   
            });
            setLoading(false)
    }
    const addNewSocialLink = (link) => {
        if(link){
            setFormData({
                ...formData,
                socialMediaLinks: {...formData.socialMediaLinks, [link]: ""}
            })
        }
        else {
            setShowOtherLinkError(false)
            const arr = formData.socialMediaLinks.other ? [...formData.socialMediaLinks.other] : []
            arr.push("")
            setFormData({
                ...formData,
                socialMediaLinks: {
                    ...formData.socialMediaLinks,
                    other: [...arr]
                }
            })
        }
        closeWithoutSaving()
    }
    const onFormDataChange = (event) => {
        setFormData({
            ...formData,
            [event.target.id]: event.target.value
        })
    }
    const onSocialMediaChange = (event) => {
        setFormData({
            ...formData,
            socialMediaLinks: {
                ...formData.socialMediaLinks,
                [event.target.id]: event.target.value
            }
        })
    }
    const handleLogoUpload = async(e) => {
        if(!e.target.files[0].type.startsWith("image/")){
            toast.error("Please upload image file only.")
            const dt = new DataTransfer()
            e.target.files = dt.files
            return
        }
        if(e.target.files && e.target.files.length > 0){
            const formData1 = new FormData();
            console.log(e.target.files[0])
            setImageFile(e.target.files[0])
            setShowModal(true)
            const dt = new DataTransfer()
            e.target.files = dt.files
        }
    }
    const removeLogo = (confirm) => {
        if(confirm){
            setFormData({
                ...formData,
                logo: ""
            })
        }
        setReoveImgToggle(false)
        setOverlay(false)
    }
    const handleSave = async(confirm) => {
        if(confirm){
            // setOtherLinksError([])
            let count = 0;
            if(formData.socialMediaLinks.other && formData.socialMediaLinks.other.length !== 0) {
                const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;
                const arr =[]
                formData.socialMediaLinks.other.map((item,index) => {
                    if (item.trim() === "") {
                        arr[index] = "required"
                        count++
                    }
                    else if(regex2.test(item) === false) {
                        arr[index] = "invalid"
                        count++
                    }
                    else {
                        arr[index] = ""
                    }
                })
                if(count > 0) {
                    setOtherLinksError(arr)
                }
            }
            // if(count > 0) {
            //     return
            // }
            const result = formValidator.current.allValid()

            if (result === false || count > 0) {
                setShowOtherLinkError(true)
                formValidator.current.showMessages()
                forceUpdate(true)
                return
            } else {
                formValidator.current.hideMessages()
                setShowOtherLinkError(false)
                forceUpdate(!update)
            }
            const apiData = transformObj()
            setEditingGeneralData(true)
            if(apiData.socialMediaLinks.other && apiData.socialMediaLinks.other.length > 0){
                apiData.socialMediaLinks.other = apiData.socialMediaLinks.other.filter(item => item !== "")
            }
            console.log("apiData------",apiData)
            let payload = {
                brandName: apiData.brandName,
                logo: apiData.logo,
                socialMediaLinks: apiData.socialMediaLinks,
                website: apiData.website
            }
            let updateResp = await context.apis[context.user.role].updateBrand(
                context.validator, {_id: (isBackendUser ? backendCompanyId : (context.user.parentBrand || context.user.brand)), sectionName: "general details"}, payload
            )

            console.log("updateResp----",updateResp);

            if(updateResp && updateResp.done){
                toast.success("Brand edited successfully")
                setEditingGeneralData(false)
                setRefetch(!refetch)
                setEditingData(false)
                setShowOtherLinkError(false)
                setFormData({})
                setGeneralDetail({})
            }
        }
        else{
            setEditingGeneralData(false)
            setShowOtherLinkError(false)
            setEditingData(false)
            setFormData({...generalDetail})
        }
    }
    const closeWithoutSaving = () => {
        setShowModalTwoMore(false)
        setOverlay(false)
    }
    const openModalTwoMore = () => {
        setShowModalTwoMore(true)
        setOverlay(true)
    }
    const onOtherMediaChange = (event, index) => {
        console.log(event.target.value)
        const arr = [...formData.socialMediaLinks.other]
        arr[index] = event.target.value
        setFormData({
            ...formData,
            socialMediaLinks: {
                ...formData.socialMediaLinks,
                other: [...arr]
            }
        })
        if(showOtherLinkError){
            const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_-]+=\w+)*)?$/;
            let errorArray = [...otherLinksError]
            if(event.target.value === ""){
                errorArray[index] = "required"
            }
            else if(regex2.test(event.target.value) === false){
                errorArray[index] = "invalid"
            }
            else if(regex2.test(event.target.value) === true){
                errorArray[index] = ""
            }
            setOtherLinksError([...errorArray])
        }
    }
    const transformObj = () => {
        console.log("formData", formData, generalDetail)
        const obj = {
            logo: formData.logo !== "" ? formData.logo[0].key || "" : "",
            brandName: formData.companyName,
            brandType: formData.brandType,
            website: formData.website,
            socialMediaLinks: {...formData.socialMediaLinks},
        }
        return obj
    }
    const deleteOtherURL = (index) => {
        const arr = objectDeepClone(formData.socialMediaLinks.other)
        arr.splice(index, 1)
        setFormData({
            ...formData,
            socialMediaLinks: {
                ...formData.socialMediaLinks,
                other: objectDeepClone(arr)
            }
        })
    }
    const validateTwitterURL = (url) => {
        // var re = new RegExp('((http://)|(www\\.))twitter\\.com/(\\w+)')
        // var re = new RegExp('((http://)|(www\\.))twitter\\.com/(\\w+)')
        // var match = url.includes('twitter.com')
        return /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?twitter.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(url)
        // return match
    }

    const validateInstaURL = (url) => {
        return /^(?:(?:http|https):\/\/)?(?:www.)?instagram.com\/(?:(?:\w)*#!\/)?/.test(url)
    }

    const validateLinkedInURL = (url) => {
        return /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(url)
    }

    const validateFacebookURL = (url) => {
        return /^(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.\*))?([\w.\-]*)?$/.test(url)
    }
    formValidator.current.rules['twitter_url'] = {
        message: 'Please enter valid twitter url.',
        rule: (val) => {
            let returnValue = validateTwitterURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['instagram_url'] = {
        message: 'Please enter valid instagram url.',
        rule: (val) => {
            let returnValue = validateInstaURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['facebook_url'] = {
        message: 'Please enter valid facebook url.',
        rule: (val) => {
            let returnValue = validateFacebookURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['linkedin_url'] = {
        message: 'Please enter valid linkedIn url.',
        rule: (val) => {
            let returnValue = validateLinkedInURL(val)
            return returnValue
        },
    }
    console.log("formData=====",formData, backendUserRole, isBackendUser);
    formValidator.current.rules['website'] = {
        message: 'Please enter valid company website.',
        rule: (val) => {
            let returnValue = true
            if (!val || val.trim() === "") {
                returnValue = false
            }
            const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
            if (!regex2.test(val)) {
                returnValue = false
            }

            return returnValue
        },
    }

    return (
        <>
            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 pl pr">
                <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-12 col-xs-12">
                        <div className="profile-general">
                            {
                                isBackendUser ?
                                <h2 className="htx3 clearfix">General {!editingData && (backendUserRole === "backendAdmin" || backendUserRole === "backendSales" || backendUserRole === "backendTech") && <a href="javascript:void(0)" className="editbtn" onClick={() => setEditingData(true)}><img src={editSvg} /> Edit</a>}</h2>
                                :
                                isBackendUser === undefined
                                ?
                                <h2 className="htx3 clearfix">General {!editingData && <a href="javascript:void(0)" className="editbtn" onClick={() => setEditingData(true)}><img src={editSvg} /> Edit</a>}</h2>
                                :
                                ""
                            }
                            <p className="ptx clearfix">
                                {
                                    isBackendUser 
                                    ?
                                    'Your company logo, name, URL.'
                                    :
                                    'Edit/Update your company logo, name, URL or type.'
                                }
                            </p>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-xs-12 brand-general ">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                <div className="profile-general-upload-img">
                                    <div className="profile-general-logo">
                                        <div className="profile-general-logo-img">
                                            <img src={editingData ? formData.logo !== "" && formData.logo[0].image ? formData.logo[0].image : noImg : generalDetail.logo !== "" && generalDetail.logo[0].image ? generalDetail.logo[0].image : noImg} />
                                        </div>
                                    </div>
                                    {editingData && 
                                        <div className="profile-general-upload btn-outline">
                                            <input type="file" accept="image/*" onChange={(e) => handleLogoUpload(e)} />
                                            <label>UPLOAD NEW IMAGE</label>
                                        </div>
                                    }
                                    {editingData && formData.logo !== "" && formData.logo.length !== 0 && formData.logo[0].image && <a style={{cursor: "pointer"}} className="viewwLink" onClick={() => {setReoveImgToggle(true); setOverlay(true)}}>Remove</a>}
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                <div className="inventory-overHead"><p>Company Name</p><h3>{formData?.companyName || formData?.brandName}</h3></div>
                            </div>
                            {
                                !isBackendUser && 
                                <>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12"><div className="clearfix mt-10"></div></div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <div className="inventory-overHead"><p>Company Category</p><h3>{formData?.brandType || "-"}</h3></div>
                                    </div>
                                </>
                            }
                            
                            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12"><div className="clearfix mt-10"></div></div>
                            
                            {
                                context.user.role === "brandManager"
                                &&
                                <>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <div className="inventory-overHead"><p>Brand Name</p><h3>{formData?.brandName || "-"}</h3></div>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12"><div className="clearfix mt-10"></div></div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <div className="inventory-overHead"><p>Brand Category</p><h3>{formData?.subCategory || "-"}</h3></div>
                                    </div>
                                    {/* <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12"><div className="clearfix mt-30"></div></div> */}
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12"><div className="clearfix mt-10"></div></div>

                                </>
                            }
                            
                            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                <div className="forminpt">
                                {editingData ? 
                                    <TextField
                                        formData={formData}
                                        formKey='website'
                                        onDataChange={onFormDataChange}
                                        label={isBackendUser ? 'Company URL' : 'Website URL'}
                                        placeholder={isBackendUser ? 'Enter Company URL' : 'Enter Website URL'}
                                        isRequired={false}
                                        formValidator={formValidator}
                                        validation='required|website'
                                    />
                                    :
                                    <>
                                        <div className="inventory-overHead"><p>{isBackendUser ? 'Company URL' : 'Website URL' }</p><h3>{formData.website || "-"}</h3></div>
                                    </>
                                }
                                </div>
                            </div>
                            {
                                !isBackendUser
                                &&
                                <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mt-20 mb-10">
                                <div className="social-general-main">
                                    <h2 className="htx3 clearfix mb-20">Social Media Links</h2>
                                    {editingData ? 
                                        <>
                                            {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("twitter") &&
                                                <div className="social-general forminpt">
                                                    <span>
                                                        <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20.9691 1L21.7174 0.948932C21.697 0.65034 21.5011 0.392447 21.2189 0.292796C20.9366 0.193144 20.6222 0.270812 20.4189 0.4904L20.9691 1ZM20.2928 5.10624C20.2928 4.69202 19.957 4.35623 19.5428 4.35623C19.1286 4.35623 18.7928 4.69202 18.7928 5.10624H20.2928ZM11 6.34286V7.09286H11.75V6.34286H11ZM2.42637 1L3.12618 0.730267C3.01989 0.454488 2.76154 0.266849 2.46641 0.25107C2.17127 0.23529 1.89439 0.394313 1.7593 0.657186L2.42637 1ZM8 13.6286L8.52301 14.1661C8.7114 13.9828 8.79009 13.7143 8.73041 13.4583C8.67073 13.2023 8.4814 12.9962 8.23137 12.9152L8 13.6286ZM1 16.2653V15.5153C0.667752 15.5153 0.375101 15.7339 0.280826 16.0525C0.186551 16.3711 0.313122 16.7137 0.591869 16.8945L1 16.2653ZM18.4515 2.35081L17.9025 2.86181L18.1709 3.15017L18.5607 3.09283L18.4515 2.35081ZM20.2209 1.05107C20.2943 2.12631 20.2255 2.76935 20.0505 3.24863C19.8808 3.71326 19.5835 4.10066 19.0318 4.6143L20.0538 5.71223C20.6807 5.1287 21.1726 4.54874 21.4595 3.76316C21.741 2.99224 21.7961 2.10222 21.7174 0.948932L20.2209 1.05107ZM20.2928 6.11734V5.16327H18.7928V6.11734H20.2928ZM20.2928 5.16327V5.10624H18.7928V5.16327H20.2928ZM10.25 5.37143V6.34286H11.75V5.37143H10.25ZM15.3223 0.25C12.4943 0.25 10.25 2.64475 10.25 5.37143H11.75C11.75 3.4365 13.3589 1.75 15.3223 1.75V0.25ZM18.7928 6.11734C18.7928 12.0684 13.6398 17.25 7.5 17.25V18.75C14.4567 18.75 20.2928 12.9083 20.2928 6.11734H18.7928ZM1.72655 1.26973C2.52294 3.33594 5.48299 7.09286 11 7.09286V5.59286C6.24717 5.59286 3.75616 2.36474 3.12618 0.730267L1.72655 1.26973ZM1.7593 0.657186C0.259127 3.57631 -0.0106888 6.45179 1.04745 8.91167C2.10404 11.3679 4.41833 13.2555 7.76863 14.342L8.23137 12.9152C5.16302 11.9201 3.26412 10.2688 2.42538 8.31894C1.58818 6.3727 1.74087 3.97471 3.09343 1.34281L1.7593 0.657186ZM7.47699 13.091C6.63496 13.9103 4.1884 15.5153 1 15.5153V17.0153C4.65816 17.0153 7.46324 15.1972 8.52301 14.1661L7.47699 13.091ZM19.0005 1.83982C18.0899 0.861517 16.7767 0.25 15.3223 0.25V1.75C16.35 1.75 17.2687 2.18081 17.9025 2.86181L19.0005 1.83982ZM18.5607 3.09283C19.6503 2.93252 20.7168 2.37623 21.5194 1.5096L20.4189 0.4904C19.8435 1.11164 19.0859 1.4994 18.3423 1.6088L18.5607 3.09283ZM0.591869 16.8945C2.89228 18.3866 5.10563 18.75 7.5 18.75V17.25C5.28463 17.25 3.38682 16.9195 1.40813 15.6361L0.591869 16.8945Z" fill="#070707"/> </svg>
                                                    </span>
                                                    <TextField
                                                        formData={formData.socialMediaLinks}
                                                        formKey='twitter'
                                                        onDataChange={onSocialMediaChange}
                                                        placeholder='Enter Twitter URL'
                                                        isRequired={false}
                                                        formValidator={formValidator}
                                                        validation='twitter_url'
                                                    />
                                                </div>
                                            }
                                            {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("linkedIn") &&
                                                <div className="social-general forminpt">
                                                    <span>
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 8.5V16.5M16 16.5V12.5C16 10.567 14.433 9 12.5 9C10.567 9 9 10.567 9 12.5V16.5V8.5M5.5 6H6.5M2 1H20C20.5523 1 21 1.44772 21 2V20C21 20.5523 20.5523 21 20 21H2C1.44772 21 1 20.5523 1 20V2C1 1.44772 1.44772 1 2 1Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                                    </span>
                                                    <TextField
                                                        formData={formData.socialMediaLinks}
                                                        formKey='linkedIn'
                                                        onDataChange={onSocialMediaChange}
                                                        placeholder='Enter LinkedIn URL'
                                                        isRequired={false}
                                                        formValidator={formValidator}
                                                        validation='linkedin_url'
                                                    />
                                                </div>
                                            }
                                            {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("instagram") &&
                                                <div className="social-general forminpt">
                                                    <span>
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.5 6H17.5M5 1H17C19.2091 1 21 2.79086 21 5V17C21 19.2091 19.2091 21 17 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1ZM11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                                    </span>
                                                    <TextField
                                                        formData={formData.socialMediaLinks}
                                                        formKey='instagram'
                                                        onDataChange={onSocialMediaChange}
                                                        placeholder='Enter Instagram URL'
                                                        isRequired={false}
                                                        formValidator={formValidator}
                                                        validation='instagram_url'
                                                    />
                                                </div>
                                            }
                                            {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("facebook") &&
                                                <div className="social-general forminpt">
                                                    <span>
                                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5ZM11.5 21.5V9.5C11.5 8.39543 12.3954 7.5 13.5 7.5H15M8 13.5H15" stroke="#070707" stroke-width="1.5"/> </svg>
                                                    </span>
                                                    <TextField
                                                        formData={formData.socialMediaLinks}
                                                        formKey='facebook'
                                                        onDataChange={onSocialMediaChange}
                                                        placeholder='Enter Facebook URL'
                                                        isRequired={false}
                                                        formValidator={formValidator}
                                                        validation='facebook_url'
                                                    />
                                                </div>
                                            }
                                            
                                            {formData.socialMediaLinks && formData.socialMediaLinks.other && formData.socialMediaLinks.other.length !== 0 && formData.socialMediaLinks.other.map((other, index) => (
                                                <React.Fragment key={index}>
                                                    <div className="social-general forminpt socialmarge">
                                                        <span>
                                                            <img src={noImg} />
                                                        </span>
                                                        <TextField
                                                            formData={formData.socialMediaLinks.other}
                                                            formKey={`url`}
                                                            onDataChange={(event) => onOtherMediaChange(event, index)}
                                                            placeholder='Enter URL'
                                                            isRequired={false}
                                                            urlErrors={otherLinksError}
                                                            showUrlErrors={showOtherLinkError}
                                                            // formValidator={formValidator}
                                                            // validation='url'
                                                            index={index}
                                                        />
                                                        <span className="trashIcon">
                                                            <a onClick={() => deleteOtherURL(index)} href="javascript:void(0)">
                                                                <img src={deleteImg} width="20" />
                                                            </a>
                                                        </span>
                                                    </div>
                                                </React.Fragment>
                                            ))

                                            }
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <div className="load-more mt-10">
                                                    <a href='javascript:void(0)' onClick={openModalTwoMore} className="viewwLink" data-target='inventoryMore'>more</a>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="social-links-popup">
                                            <ul>
                                                {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("twitter") && formData.socialMediaLinks.twitter &&
                                                    <li>
                                                        <a href={addHttpsInUrl(formData.socialMediaLinks.twitter)} target="_blank"><svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20.9691 1L21.7174 0.948932C21.697 0.65034 21.5011 0.392447 21.2189 0.292796C20.9366 0.193144 20.6222 0.270812 20.4189 0.4904L20.9691 1ZM20.2928 5.10624C20.2928 4.69202 19.957 4.35623 19.5428 4.35623C19.1286 4.35623 18.7928 4.69202 18.7928 5.10624H20.2928ZM11 6.34286V7.09286H11.75V6.34286H11ZM2.42637 1L3.12618 0.730267C3.01989 0.454488 2.76154 0.266849 2.46641 0.25107C2.17127 0.23529 1.89439 0.394313 1.7593 0.657186L2.42637 1ZM8 13.6286L8.52301 14.1661C8.7114 13.9828 8.79009 13.7143 8.73041 13.4583C8.67073 13.2023 8.4814 12.9962 8.23137 12.9152L8 13.6286ZM1 16.2653V15.5153C0.667752 15.5153 0.375101 15.7339 0.280826 16.0525C0.186551 16.3711 0.313122 16.7137 0.591869 16.8945L1 16.2653ZM18.4515 2.35081L17.9025 2.86181L18.1709 3.15017L18.5607 3.09283L18.4515 2.35081ZM20.2209 1.05107C20.2943 2.12631 20.2255 2.76935 20.0505 3.24863C19.8808 3.71326 19.5835 4.10066 19.0318 4.6143L20.0538 5.71223C20.6807 5.1287 21.1726 4.54874 21.4595 3.76316C21.741 2.99224 21.7961 2.10222 21.7174 0.948932L20.2209 1.05107ZM20.2928 6.11734V5.16327H18.7928V6.11734H20.2928ZM20.2928 5.16327V5.10624H18.7928V5.16327H20.2928ZM10.25 5.37143V6.34286H11.75V5.37143H10.25ZM15.3223 0.25C12.4943 0.25 10.25 2.64475 10.25 5.37143H11.75C11.75 3.4365 13.3589 1.75 15.3223 1.75V0.25ZM18.7928 6.11734C18.7928 12.0684 13.6398 17.25 7.5 17.25V18.75C14.4567 18.75 20.2928 12.9083 20.2928 6.11734H18.7928ZM1.72655 1.26973C2.52294 3.33594 5.48299 7.09286 11 7.09286V5.59286C6.24717 5.59286 3.75616 2.36474 3.12618 0.730267L1.72655 1.26973ZM1.7593 0.657186C0.259127 3.57631 -0.0106888 6.45179 1.04745 8.91167C2.10404 11.3679 4.41833 13.2555 7.76863 14.342L8.23137 12.9152C5.16302 11.9201 3.26412 10.2688 2.42538 8.31894C1.58818 6.3727 1.74087 3.97471 3.09343 1.34281L1.7593 0.657186ZM7.47699 13.091C6.63496 13.9103 4.1884 15.5153 1 15.5153V17.0153C4.65816 17.0153 7.46324 15.1972 8.52301 14.1661L7.47699 13.091ZM19.0005 1.83982C18.0899 0.861517 16.7767 0.25 15.3223 0.25V1.75C16.35 1.75 17.2687 2.18081 17.9025 2.86181L19.0005 1.83982ZM18.5607 3.09283C19.6503 2.93252 20.7168 2.37623 21.5194 1.5096L20.4189 0.4904C19.8435 1.11164 19.0859 1.4994 18.3423 1.6088L18.5607 3.09283ZM0.591869 16.8945C2.89228 18.3866 5.10563 18.75 7.5 18.75V17.25C5.28463 17.25 3.38682 16.9195 1.40813 15.6361L0.591869 16.8945Z" fill="#070707"/> </svg></a>
                                                    </li>
                                                }
                                                {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("linkedIn") && formData.socialMediaLinks.linkedIn &&
                                                    <li>
                                                        <a href={addHttpsInUrl(formData.socialMediaLinks.linkedIn)} target="_blank"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 8.5V16.5M16 16.5V12.5C16 10.567 14.433 9 12.5 9C10.567 9 9 10.567 9 12.5V16.5V8.5M5.5 6H6.5M2 1H20C20.5523 1 21 1.44772 21 2V20C21 20.5523 20.5523 21 20 21H2C1.44772 21 1 20.5523 1 20V2C1 1.44772 1.44772 1 2 1Z" stroke="#070707" stroke-width="1.5"/> </svg></a>
                                                    </li>
                                                }
                                                {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("instagram") && formData.socialMediaLinks.instagram &&
                                                    <li>
                                                        <a href={addHttpsInUrl(formData.socialMediaLinks.instagram)} target="_blank"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.5 6H17.5M5 1H17C19.2091 1 21 2.79086 21 5V17C21 19.2091 19.2091 21 17 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1ZM11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15Z" stroke="#070707" stroke-width="1.5"/> </svg></a>
                                                    </li>
                                                }
                                                {formData.socialMediaLinks && formData.socialMediaLinks.hasOwnProperty("facebook") && formData.socialMediaLinks.facebook &&
                                                    <li>
                                                        <a href={addHttpsInUrl(formData.socialMediaLinks.facebook)} target="_blank"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5ZM11.5 21.5V9.5C11.5 8.39543 12.3954 7.5 13.5 7.5H15M8 13.5H15" stroke="#070707" stroke-width="1.5"/> </svg></a>
                                                    </li>
                                                }
                                                {
                                                    formData.socialMediaLinks.other && formData.socialMediaLinks.other.length > 0 &&
                                                    formData.socialMediaLinks.other.map(link=>{
                                                        return(
                                                            <li>
                                                                <a href={addHttpsInUrl(link)} target='_blank'><img src={noImg} /></a>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                {editingData &&
                    <div className="col-xl-10 col-lg-10 col-md-12 col-xs-12 mb-20">
                        <div className="btn-general">
                            <a style={{cursor: "pointer"}} className="btn btn-outline" onClick={() => handleSave(false)}>Cancel</a>
                            <a style={{cursor: "pointer"}} className={`btn btn-orange ${editingGeneralData && "button--loading btn-disabled"}`} onClick={() => handleSave(true)}>Save Changes</a>
                        </div>
                    </div>
                }
                <ImageCroper
                    setOverlay={setOverlay}
                    imageFile={imageFile}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    setLogo={setLogo}
                />
                <div id="social-links" className={`popup ${showModalTwoMore === false ? "hide" : ""}`}>
                    <div className="popup-header">
                        <h3 className="htx2 pophead">Add more Social Medial Links</h3>
                        <span className="close toggle" onClick={closeWithoutSaving} data-target="myPopup">close</span> 
                    </div>
                    <div className="popup-body">
                        <div className="social-links-popup">
                            <ul>
                                {formData.socialMediaLinks && !formData.socialMediaLinks.hasOwnProperty("twitter") &&
                                    <li onClick={() => addNewSocialLink("twitter")}>
                                        <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20.9691 1L21.7174 0.948932C21.697 0.65034 21.5011 0.392447 21.2189 0.292796C20.9366 0.193144 20.6222 0.270812 20.4189 0.4904L20.9691 1ZM20.2928 5.10624C20.2928 4.69202 19.957 4.35623 19.5428 4.35623C19.1286 4.35623 18.7928 4.69202 18.7928 5.10624H20.2928ZM11 6.34286V7.09286H11.75V6.34286H11ZM2.42637 1L3.12618 0.730267C3.01989 0.454488 2.76154 0.266849 2.46641 0.25107C2.17127 0.23529 1.89439 0.394313 1.7593 0.657186L2.42637 1ZM8 13.6286L8.52301 14.1661C8.7114 13.9828 8.79009 13.7143 8.73041 13.4583C8.67073 13.2023 8.4814 12.9962 8.23137 12.9152L8 13.6286ZM1 16.2653V15.5153C0.667752 15.5153 0.375101 15.7339 0.280826 16.0525C0.186551 16.3711 0.313122 16.7137 0.591869 16.8945L1 16.2653ZM18.4515 2.35081L17.9025 2.86181L18.1709 3.15017L18.5607 3.09283L18.4515 2.35081ZM20.2209 1.05107C20.2943 2.12631 20.2255 2.76935 20.0505 3.24863C19.8808 3.71326 19.5835 4.10066 19.0318 4.6143L20.0538 5.71223C20.6807 5.1287 21.1726 4.54874 21.4595 3.76316C21.741 2.99224 21.7961 2.10222 21.7174 0.948932L20.2209 1.05107ZM20.2928 6.11734V5.16327H18.7928V6.11734H20.2928ZM20.2928 5.16327V5.10624H18.7928V5.16327H20.2928ZM10.25 5.37143V6.34286H11.75V5.37143H10.25ZM15.3223 0.25C12.4943 0.25 10.25 2.64475 10.25 5.37143H11.75C11.75 3.4365 13.3589 1.75 15.3223 1.75V0.25ZM18.7928 6.11734C18.7928 12.0684 13.6398 17.25 7.5 17.25V18.75C14.4567 18.75 20.2928 12.9083 20.2928 6.11734H18.7928ZM1.72655 1.26973C2.52294 3.33594 5.48299 7.09286 11 7.09286V5.59286C6.24717 5.59286 3.75616 2.36474 3.12618 0.730267L1.72655 1.26973ZM1.7593 0.657186C0.259127 3.57631 -0.0106888 6.45179 1.04745 8.91167C2.10404 11.3679 4.41833 13.2555 7.76863 14.342L8.23137 12.9152C5.16302 11.9201 3.26412 10.2688 2.42538 8.31894C1.58818 6.3727 1.74087 3.97471 3.09343 1.34281L1.7593 0.657186ZM7.47699 13.091C6.63496 13.9103 4.1884 15.5153 1 15.5153V17.0153C4.65816 17.0153 7.46324 15.1972 8.52301 14.1661L7.47699 13.091ZM19.0005 1.83982C18.0899 0.861517 16.7767 0.25 15.3223 0.25V1.75C16.35 1.75 17.2687 2.18081 17.9025 2.86181L19.0005 1.83982ZM18.5607 3.09283C19.6503 2.93252 20.7168 2.37623 21.5194 1.5096L20.4189 0.4904C19.8435 1.11164 19.0859 1.4994 18.3423 1.6088L18.5607 3.09283ZM0.591869 16.8945C2.89228 18.3866 5.10563 18.75 7.5 18.75V17.25C5.28463 17.25 3.38682 16.9195 1.40813 15.6361L0.591869 16.8945Z" fill="#070707"/> </svg>
                                    </li>
                                }
                                {formData.socialMediaLinks && !formData.socialMediaLinks.hasOwnProperty("linkedIn") &&
                                    <li onClick={() => addNewSocialLink("linkedIn")}>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 8.5V16.5M16 16.5V12.5C16 10.567 14.433 9 12.5 9C10.567 9 9 10.567 9 12.5V16.5V8.5M5.5 6H6.5M2 1H20C20.5523 1 21 1.44772 21 2V20C21 20.5523 20.5523 21 20 21H2C1.44772 21 1 20.5523 1 20V2C1 1.44772 1.44772 1 2 1Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                    </li>
                                }
                                {formData.socialMediaLinks && !formData.socialMediaLinks.hasOwnProperty("instagram") &&
                                    <li onClick={() => addNewSocialLink("instagram")}>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.5 6H17.5M5 1H17C19.2091 1 21 2.79086 21 5V17C21 19.2091 19.2091 21 17 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1ZM11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                    </li>
                                }
                                {formData.socialMediaLinks && !formData.socialMediaLinks.hasOwnProperty("facebook") &&
                                    <li onClick={() => addNewSocialLink("facebook")}>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5ZM11.5 21.5V9.5C11.5 8.39543 12.3954 7.5 13.5 7.5H15M8 13.5H15" stroke="#070707" stroke-width="1.5"/> </svg>
                                    </li>
                                }
                            <li onClick={() => addNewSocialLink("")} className="add-social"><a href="javascript:void(0);"><img src={plusIcon}/></a></li>
                            </ul>
                            <div className="clearfix mt-10"></div>
                            {/* <a href="javascript:void(0);" className="btn btn-orange brand-btn">ADD</a> */}
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmDialog
                togglePopup={reoveImgToggle}
                onModalClose={removeLogo}
                componentName={""}
                confirmTitle="Do you want to remove logo?"
            />
        </>
    )
}

export default EditGeneral
